import axiosPost from '../axiosPost';

export const tiposDeDomicilioUpd = async (arg) => {
    const { id, nombre, codigo, version } = arg;

    const body = {
        "service": "TipoDeDomicilioUpd",
        "params": {
            "tipoDeDomicilioId": id,
            "tipoDeDomicilioNombre": nombre,
            "tipoDeDomicilioCod": codigo,
            "tipoDeDomicilioVersion": version,
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}